import { useEffect, useRef } from "react";

/** The shared URL identifies the round; the existing source reader still authorizes access. */
export function useResultLink(
  accountId: string,
  enabled: boolean,
  onOpen: (id: string) => void,
) {
  const current = useRef(onOpen);
  current.current = onOpen;
  useEffect(() => {
    if (!enabled) return;
    const read = () => {
      const url = new URL(window.location.href);
      const id = url.searchParams.get("result");
      if (
        !id ||
        !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu.test(
          id,
        )
      )
        return;
      url.searchParams.delete("result");
      window.history.replaceState(
        null,
        "",
        url.pathname + url.search + url.hash,
      );
      current.current(id);
    };
    read();
    window.addEventListener("popstate", read);
    return () => window.removeEventListener("popstate", read);
  }, [accountId, enabled]);
}
